import { oz } from '@weft/utils';

export const NetSuiteInvoiceItemSchema = oz.object({
  item: oz.object({
    id: oz.string(),
  }),
  quantity: oz.number(),
  amount: oz.number(),
  description: oz.string().optional(),
  memo: oz.string().optional(),
});

export type NetSuiteInvoiceItem = oz.infer<typeof NetSuiteInvoiceItemSchema>;